import React from 'react';
import { Card } from '../../../components/ui/card';
import { AlertTriangle, CheckCircle, Clock, DollarSign } from 'lucide-react';
import { formatRupiah } from '../recruitment/utils/formatRupiah';

// Format hours with proper decimal formatting (simpler version for stats)
const formatHours = (hours: any): string => {
  if (!hours) return '0h';
  const numHours = typeof hours === 'string' ? parseFloat(hours) : Number(hours);
  if (isNaN(numHours) || numHours === 0) return '0h';
  // Format with 2 decimal places
  const formatted = numHours.toFixed(2);
  const parts = formatted.split('.');
  // Add thousand separators to integer part (no padding)
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${integerPart}.${parts[1]}h`;
};

export default function OvertimeStats({ stats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <Card className="border-l-4 border-l-amber-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Menunggu</p>
              <p className="text-2xl font-bold">{stats.pending || 0}</p>
            </div>
            <AlertTriangle className="w-8 h-8 text-amber-500" />
          </div>
        </div>
      </Card>
      <Card className="border-l-4 border-l-green-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Disetujui</p>
              <p className="text-2xl font-bold">{stats.approved || 0}</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-500" />
          </div>
        </div>
      </Card>
      <Card className="border-l-4 border-l-blue-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Total Jam</p>
              <p className="text-xl font-bold text-blue-600">
                {formatHours(stats.totalHours || 0)}
              </p>
            </div>
            <Clock className="w-8 h-8 text-blue-500" />
          </div>
        </div>
      </Card>
      <Card className="border-l-4 border-l-emerald-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Total Bonus</p>
              <p className="text-xl font-bold">Rp {formatRupiah(stats.totalAmount || 0)}</p>
            </div>
            <DollarSign className="w-8 h-8 text-emerald-500" />
          </div>
        </div>
      </Card>
    </div>
  );
}
